// extracted by mini-css-extract-plugin
module.exports = {"SideLinks":"SideLinks_SideLinks__2_sR4","Left":"SideLinks_Left__2lfRW","left":"SideLinks_left__3F7RD"};